import type {
  CardItemBreederData,
  CardItemLitterData,
  JoinBannerData,
  PromoNewsletterData,
} from '@presentation/components';
import type { MouseEventHandler, ReactNode } from 'react';

export interface PopularBreedItems {
  name: string;
  image?: string;
  link: string;
}

export interface PopularBreedData {
  items: PopularBreedItems[];
  moreItems: PopularBreedItems[];
  showMore: boolean;
  onShowMore(): void;
}

export interface HomeLandingPageData {
  joinBanner: JoinBannerData;
  promoNewletter: PromoNewsletterData;

  litterItems?: CardItemLitterData[];
  breederItems?: CardItemBreederData[];

  litterItemsLoading?: boolean;
  breederItemsLoading?: boolean;

  popularLitterCategoriesByBreed?: PopularBreedData;
  popularBreederCategoriesByBreed?: PopularBreedData;

  breedInterestBanner?: ReactNode;

  onContactClick?: MouseEventHandler;
  onMoreLittersClick?: MouseEventHandler;
  onMoreBreedersclick?: MouseEventHandler;
  onBuyClick?: MouseEventHandler;
  onStoryClick?: MouseEventHandler;
  onSellClick?: MouseEventHandler;
}

export interface HomeLandingPageProps extends HomeLandingPageData {}
